import React from "react";

import {cn} from "@isudio/utils";
import type {IAssetFilter, IAssetSort} from "@isudio/data";

import {Button, Dropdowns, Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger} from "../../";

interface HeaderTitleNavProps {
  className?: string;
  searchRef?: React.RefObject<HTMLInputElement>;
  onFilterChange?: (filter: IAssetFilter) => void;
  onSortChange?: (sort: IAssetSort) => void;
  onSearchChange?: (search: string) => void;
}

const HeaderRightNav = React.forwardRef<Element, HeaderTitleNavProps>(
  ({
     className = "header-right-nav",
     searchRef,
     onFilterChange,
     onSortChange,
     onSearchChange
   }
  ) => {
    return (
      <nav
        className={cn(`${className}`, "flex")}>
        <div className="hidden lg:flex gap-2">
          <Dropdowns
            onFilterChange={onFilterChange}
            onSortChange={onSortChange}
          />
          <div
            className="flex justify-center align-center">
            <div className="relative">
              <input
                ref={searchRef}
                type="text"
                placeholder="Search..."
                onChange={onSearchChange ? (e) => onSearchChange(e.target.value) : undefined}
                className="w-60 h-8 pl-8 pr-3 py-2 text-sm border-none focus:outline-none focus:ring-0 bg-bluegray-darker text-white placeholder-bluegray-lighter rounded-[25px]"
              />
              <i
                className="fa-duotone fa-light fa-magnifying-glass text-sm text-bluegray-lighter absolute! left-3 top-2.25"/>
            </div>
          </div>
        </div>

        <div className="lg:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button
                variant="vanilla"
                tabIndex={-1}
                className={cn(className, "cursor-pointer")}
              >
                <i
                  className={`fa-duotone fa-light fa-sliders text-2xl`}/>
              </Button>
            </SheetTrigger>

            <SheetContent className="sort-filter-sheet bg-bluegray-darker/85 border-none!">
              <SheetHeader>
                <SheetTitle className="text-lg text-white font-bold tracking-wider">Filter, Sort & Search</SheetTitle>
              </SheetHeader>

              <div className="flex flex-col gap-4 mt-6">
                <Dropdowns
                  onFilterChange={onFilterChange}
                  onSortChange={onSortChange}
                />
                <div
                  className="flex justify-center align-center">
                  <div className="relative">
                    <input
                      ref={searchRef}
                      type="text"
                      placeholder="Search..."
                      onChange={onSearchChange ? (e) => onSearchChange(e.target.value) : undefined}
                      className="w-60 h-8 pl-8 pr-3 py-2 text-sm border-none focus:outline-none focus:ring-0 bg-bluegray-darker text-white placeholder-generic-dull rounded-[25px]"
                    />
                    <i
                      className="fa-duotone fa-light fa-magnifying-glass text-sm text-bluegray-lighter absolute! left-3 top-2.25"/>
                    </div>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    )
  }
);

HeaderRightNav.displayName = "HeaderRightNav"
export {HeaderRightNav}